import type { ColDef } from 'ag-grid-community';
import type { TFunction } from 'i18next';

const useColdefConditionOrdinaryExport = (t: TFunction<'translation', undefined>) => {
  const colDefs: ColDef[] = [
    {
      headerName: '',
      colId: 'actions',
      cellRenderer: 'actionsManageCondition',
      editable: false,
      filter: false,
      pinned: 'left',
      suppressMenu: true,
      cellStyle: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      },
      minWidth: 90,
      maxWidth: 90,
    },
    {
      field: 'customer',
      headerName: t('condition.customer'),
      headerTooltip: t('condition.customer'),
      width: 150,
    },
    {
      field: 'customerName',
      headerName: t('condition.customerName'),
      headerTooltip: t('condition.customerName'),
      width: 400,
    },
  ];

  return colDefs;
};

export default useColdefConditionOrdinaryExport;
